var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65039 7.63496C7.65039 7.40953 7.73994 7.19333 7.89935 7.03392C8.05876 6.87452 8.27496 6.78496 8.50039 6.78496C8.72582 6.78496 8.94203 6.87452 9.10143 7.03392C9.26084 7.19333 9.35039 7.40953 9.35039 7.63496V12.735C9.35039 12.9604 9.26084 13.1766 9.10143 13.336C8.94203 13.4954 8.72582 13.585 8.50039 13.585C8.27496 13.585 8.05876 13.4954 7.89935 13.336C7.73994 13.1766 7.65039 12.9604 7.65039 12.735V7.63496ZM8.50039 3.44531C8.27496 3.44531 8.05876 3.53487 7.89935 3.69427C7.73994 3.85368 7.65039 4.06988 7.65039 4.29531C7.65039 4.52075 7.73994 4.73695 7.89935 4.89635C8.05876 5.05576 8.27496 5.14531 8.50039 5.14531C8.72582 5.14531 8.94203 5.05576 9.10143 4.89635C9.26084 4.73695 9.35039 4.52075 9.35039 4.29531C9.35039 4.06988 9.26084 3.85368 9.10143 3.69427C8.94203 3.53487 8.72582 3.44531 8.50039 3.44531Z",
    fill: "#FF7925"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C3.80545 0 0 3.80545 0 8.5C0 13.1946 3.80545 17 8.5 17C13.1946 17 17 13.1946 17 8.5C17 3.80545 13.1946 0 8.5 0ZM1.7 8.5C1.7 10.3035 2.41643 12.0331 3.69167 13.3083C4.96692 14.5836 6.69653 15.3 8.5 15.3C10.3035 15.3 12.0331 14.5836 13.3083 13.3083C14.5836 12.0331 15.3 10.3035 15.3 8.5C15.3 6.69653 14.5836 4.96692 13.3083 3.69167C12.0331 2.41643 10.3035 1.7 8.5 1.7C6.69653 1.7 4.96692 2.41643 3.69167 3.69167C2.41643 4.96692 1.7 6.69653 1.7 8.5Z",
    fill: "#FF7925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTnc);
export default __webpack_public_path__ + "static/media/ic-tnc.ac8af7598b2937ddca7349afeb774652.svg";
export { ForwardRef as ReactComponent };